module.exports = __webpack_public_path__ + "img/love3.c7c5356f.png";